import Base from "../Step.es6";

// Edit users image
export default class extends Base {
    constructor(Configurator) {
        super('edit', Configurator.mode.DESIGN_USER, Configurator);
        this.level      = Configurator.PURCHASE_LEVEL_HIGH;
        this.values     = {
            url:        App.Utilities.String.EMPTY_STRING,
            modifiers:  App.Utilities.String.EMPTY_STRING,
        };
    }

    get value() { return this.Configurator.Progress.get('upload').values.image }
    get url() {
        const query = {
            image:  this.value,
            name:   this.Configurator.Progress.get('text').values.name,
            color:  this.Configurator.Progress.get('color').values.color || App.Variable('color'),
            id:     this.Configurator.id,
        }
        return 'editor?' + URI.buildQuery(query);
    }

    required() {
        return ['upload'];
    }

    validate() {
        return this.values.modifiers && this.hasImage();
    }
    commit(values) {
        this.values.url         = values.cdnUrl;
        this.values.modifiers   = values.cdnUrlModifiers;
        return this;
    }
    remove() {
        const Configurator       = this.Configurator;
        this.values.url          = App.Utilities.String.EMPTY_STRING;
        this.values.modifiers    = null;
        this.ready               = false;
        Configurator.Progress.get('color').remove();
        return this;
    }
    run() {
        App.Interface.Notification.reset();
        this.Configurator.Preview.prepareTin();
        return this;
    }
    hasImage() {
        return this.values.url !== App.Utilities.String.EMPTY_STRING;
    }
}
